var map = {
	"./check.png": 1034,
	"./error.png": 1644,
	"./graphic3.svg": 9541,
	"./graphic7.svg": 7177,
	"./img/rev.png": 8717,
	"./logo.png": 3153,
	"./logocafeteria.png": 9535,
	"./logopritypay.png": 4981,
	"./logoyayas.png": 1554,
	"./whatsapp.png": 650,
	"./yappy-c.png": 5225
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;